const initPendo = (data, account) =>
  window?.pendo.initialize({
    visitor: {
      ...data,
    },
    account,
  });

export default initPendo;
